<script setup lang="ts">
defineProps<{
    icon: string;
    iconSizePx?: string;
    title?: string;
    description?: string;
}>();
</script>

<template>
    <q-card class="container-shadow q-pa-md full-height">
        <div class="row flex-grow item full-height">
            <div class="q-mr-sm">
                <q-icon class="icon" :name="icon" :size="iconSizePx ? `${iconSizePx}px` : '40px'" />
            </div>
            <template v-if="$slots.content">
                <slot name="content" />
            </template>
            <template v-else>
                <div :class="{ 'q-mr-lg col': $q.screen.gt.xs, 'col-8': $q.screen.lt.sm }">
                    <h3 class="title qit-text-ellipsis-2-lines">{{ title }}</h3>
                    <div class="qit-text-ellipsis-2-lines">{{ description }}</div>
                </div>
                <div class="col-auto q-ml-auto content-end" :class="{ 'q-mt-sm': $q.screen.lt.md }">
                    <slot name="button" />
                </div>
            </template>
        </div>
    </q-card>
</template>

<style lang="scss" scoped>
.title {
    font-size: 14px;
    font-weight: $semi-bold;
    margin-top: 0;
    margin-bottom: $spacing-m;
}
.icon {
    width: 45px;
}
</style>
